import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { moneyFormat } from '@helpers';

import parse from 'html-react-parser';
import { Skeleton } from 'fpay-ui';
import { usePromotions } from 'hooks';

const Container = styled.div`
  width: 296px;
  height: 58px;
  border-radius: 4px;
  padding: 12px 0 12px 0;
  background: #F2F5F9;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 16px;
  & div {
    padding:  12px 9px;
    font-family: Roboto;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.41px;
    text-align: center;
    & strong {
      font-family: Roboto;
      font-size: 12px;
      font-weight: 700;
      line-height: 14.06px;
    }
  }
  
`;
const SimulationCredit = (props) => {
  const { t } = useTranslation();
  const {
    loadingSimulationCredit: isLoading,
    installmentsSimulation,
    getInstallmentsSimulation,
  } = usePromotions();

  useEffect(() => {
    getInstallmentsSimulation(props.amountCredit);
    return () => { };
  }, [props.amountCredit]);

  return (<Container>
    {isLoading || !installmentsSimulation ? (<>
      <Skeleton type="none" width="240px" height="16px" borderRadius="4px"
        style={{
          marginLeft: "auto",
          marginRight: "auto",
        }} />
      <Skeleton type="none" width="250px" height="16px" borderRadius="4px"
        style={{
          marginLeft: "auto",
          marginRight: "auto",
          marginTop: '4px',
        }} />
    </>)
      : (<div>
        {parse(t('finance.financialProductSelection.installment.simulation', {
          installments: installmentsSimulation.installments,
          installmentValue: moneyFormat(installmentsSimulation.installmentValue, true),
          totalCreditAmount: moneyFormat(installmentsSimulation.totalCreditAmount, true),
          interestRateValue: installmentsSimulation.interestRateValue
        }))}
      </div>)

    }
  </Container>)
}

export default SimulationCredit